<template>
  <section class="form__thanks">
    <div class="form__thanks__wrapper">
      <div class="form__row form__row--thanks">
        <div
          class="form__group"
          data-size="auto"
        >
          <h3 v-html="'Grazie, per averci contattati.'" />
        </div>
      </div>

      <div class="form__row form__row--thanks">
        <div
          class="form__group"
          data-size="auto"
        >
          <h5 v-html="'<em>Ti ricontatteremo<wbr> al più presto possibile.</em>'" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FormThanks',

  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.form__thanks {
  // position: absolute;
  // top: 0;
  // left: 0;
  // width: 100%;
  // height: 100%;

  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;

  &__wrapper {
    position: relative;
  }

  .form__row {
    &--thanks {
      margin: 0 0 20px 0;

      @include mq(ipadP) {
        margin: 0 0 60px 0;
      }
    }
  }

  p {
    margin: 0;
    @include fluid-type(375px, 1920px, 26px, 50px, 40px, 65px);

    color: RGB($color-text);
  }
}

.form__line {
  display: none;

  @at-root [data-theme="default"] & {
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;

    background: $color-label;
  }
}

.form__back {
  position: absolute;
  left: 0;
  bottom: 0;
  font-size: 0.875rem;

  color: RGB($color-text);

  a {
    display: inline-block;
    vertical-align: sub;
    margin-left: 2px;
  }
}
</style>
